export const getMapSlug = (propsNeedModified) => {
  const { slug, tourId } = propsNeedModified.match.params;
  const [groupId, sceneId, hotspotId] = slug
    ? slug.split('/')
    : [null, null, null];

  const modifiedProps = {
    ...propsNeedModified,
    match: {
      ...propsNeedModified.match,
      params: {
        ...propsNeedModified.match.params,
        groupId,
        sceneId,
        hotspotId,
        tourId,
      },
    },
  };

  return modifiedProps;
};
